import { compareWithAppVersion } from '@croquiscom/web2app';

import { isZigzag } from '@common/device-manager';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useSpecialTimeService = () => {
  const params = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(params);
  const endTime = product.discount_info?.end_time ?? 0;
  const discount_banner_info = product.promotion_info?.discount_banner_info;

  const useCompareAppVersion = (version: string) => isZigzag() && compareWithAppVersion(version);

  return {
    endTime,
    isHide: useCompareAppVersion('7.75.0') || !endTime || !discount_banner_info,
  };
};
